import { render, staticRenderFns } from "./Perguntas.vue?vue&type=template&id=143f192a&"
import script from "./Perguntas.vue?vue&type=script&lang=js&"
export * from "./Perguntas.vue?vue&type=script&lang=js&"
import style0 from "./Perguntas.vue?vue&type=style&index=0&id=143f192a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports